import AboutUs from "../AboutUs";

function MaisonMarlineAboutUs() {
  return (
    <AboutUs
      className="MM-about"
      titleKey="maisonMarline.about.title"
      textKey="maisonMarline.about.text"
    />
  );
}

export default MaisonMarlineAboutUs;
